module.exports = __webpack_public_path__ + "img/WSMCASINO.c4252b0e.svg";